import { render, staticRenderFns } from "./logoDecode.vue?vue&type=template&id=0852c695&scoped=true&"
import script from "./logoDecode.vue?vue&type=script&lang=js&"
export * from "./logoDecode.vue?vue&type=script&lang=js&"
import style0 from "./logoDecode.vue?vue&type=style&index=0&id=0852c695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852c695",
  null
  
)

export default component.exports